var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabel2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0933 11.5228H10.3467C10.111 11.5228 9.92001 11.3318 9.92001 11.0962V8.96H12.4242C12.5414 8.96 12.6415 8.87525 12.6609 8.7596L12.8305 7.74627C12.8549 7.59995 12.7421 7.46667 12.5937 7.46667H8.42667V11.0962C8.42667 12.1566 9.28627 13.0162 10.3467 13.0162H11.84V14.1267C11.1012 14.4074 10.4689 14.5067 9.65414 14.5067C7.57503 14.5067 6.35103 13.3524 6.29334 11.3067V7.46667H3.0763C2.95905 7.46667 2.85894 7.55141 2.83961 7.66707L2.67001 8.6804C2.64555 8.82672 2.75835 8.96 2.90673 8.96H4.80001V11.3067C4.83278 12.5867 5.16502 13.7619 6.09147 14.6958C6.93795 15.549 8.1699 16 9.65414 16C10.9046 16 11.8522 15.7933 13.0885 15.2151C13.2382 15.1452 13.3333 14.9943 13.3333 14.8291V11.7628C13.3333 11.6303 13.2259 11.5228 13.0933 11.5228Z",
    fill: "#0085FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40654 5.97333H6.29334V2.76906L8.42668 2.01362V5.97333H12.9237C13.041 5.97333 13.1411 5.88858 13.1604 5.77293L13.33 4.75959C13.3545 4.61327 13.2416 4.47999 13.0933 4.47999H9.92001V0.240179C9.92001 0.0744992 9.75609 -0.0413408 9.59988 0.0139659L4.95988 1.65706C4.86406 1.69101 4.80001 1.78165 4.80001 1.8833V4.47999H3.57612C3.45886 4.47999 3.35876 4.56474 3.3394 4.68039L3.16985 5.69373C3.14534 5.84005 3.25817 5.97333 3.40654 5.97333Z",
    fill: "#0085FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel2);
export default __webpack_public_path__ + "static/media/label-2.2e7b1cdb6b0737b9acff11cce1fb3616.svg";
export { ForwardRef as ReactComponent };